module.exports = __webpack_public_path__ + "img/icon-login-key.76da78a2.svg";